export class Point extends PIXI.Point {


  constructor(x?: number, y?: number) {
    super(x, y);
  }

  public static distance(from: PIXI.Point, to: PIXI.Point): number {
    let dx:number = to.x - from.x;
    let dy:number = to.y - from.y;
    return Math.sqrt(dx * dx + dy * dy);
  }

  public static polar(len: number, angle: number): Point {
    return new Point(Math.cos(angle) * len, Math.sin(angle) * len);
  }

  public static fromPIXIPoint(point: PIXI.Point): Point {
    return new Point(point.x, point.y);
  }

  public static fromXY(x: number, y: number): Point {
    return new Point(x, y);
  }

  public clone(): Point {
    return new Point(this.x, this.y);
  }

  public toB2Vec2(): b2Vec2 {
    return new b2Vec2(this.x, this.y);
  }

  public toScaledB2Vec2(scale: number): b2Vec2 {
    return new b2Vec2(this.x * scale, this.y * scale);
  }

  public toString(): string {
    return "" + this.x + "," + this.y;
  }

  public static fromString(str: string): Point {
    if (str) {
      var arr: Array<string> = str.split(',');
      if (arr.length == 2) {
        return new Point(parseFloat(arr[0]), parseFloat(arr[1]));
      }
    }
    return null;
  }

  public sub(other: Point): Point {
    return new Point(this.x - other.x, this.y - other.y);
  }
  public subXY(x: number, y: number): Point {
    return new Point(this.x - x, this.y - y);
  }

  public add(other: Point): Point {
    return new Point(this.x + other.x, this.y + other.y);
  }
  public addXY(x: number, y: number): Point {
    return new Point(this.x + x, this.y + y);
  }
  public get lengthSquared(): number {
    return this.x * this.x + this.y * this.y;
  }

  public get length(): number {
    return Math.sqrt(this.lengthSquared);
  }

  public distanceTo(other: Point): number {
    let dx: number = other.x - this.x;
    let dy: number = other.y - this.y;
    return Math.sqrt(dx * dx + dy * dy);
  }


  public normalize(length: number = 1): number {
    var len: number = this.length;
    if (len == 0)
      return 0;
    this.scale(length / len);
    return len;
  }

  public dot(vector: Point): number {
    return this.x * vector.x + this.y * vector.y;
  }

  public scale(value: number): void {
    this.x *= value;
    this.y *= value;
  }

  public cross(vector: Point): Point {
    var a0: number = this.y * vector.x;
    var a1: number = this.x * vector.y;
    return new Point(a0 - a1, a1 - a0);
  }

  public getNormal(): Point {
    return new Point(-this.y, this.x);
  }

  public rotate(radians: number): void {
    var cos: number = Math.cos(radians);
    var sin: number = Math.sin(radians);

    var ox: number = this.x;
    var oy: number = this.y;
    this.x = ox * cos - oy * sin;
    this.y = oy * cos + ox * sin;
  }
}



// WEBPACK FOOTER //
// ./src/framework/geom/Point.ts